import { Link } from 'react-router-dom';
import LogoFooter from './LogoFooter';

const serviceColumns = [
  {
    title: 'Baie coulissante',
    to: '/reparation-baie-coulissante-herault/',
    links: [
      { to: '/changer-roulettes-galets-baie-coulissante-herault/', label: 'Roulettes & galets' },
      { to: '/baie-coulissante-qui-coince-herault/', label: 'Baie qui coince' },
      { to: '/reparation-rail-baie-coulissante-herault/', label: 'Rail de baie' },
      { to: '/reglage-baie-coulissante-herault/', label: 'Réglage baie' },
      { to: '/serrure-cremone-baie-coulissante-herault/', label: 'Serrure & crémone' },
    ],
  },
  {
    title: 'Volet roulant',
    to: '/reparation-volet-roulant-herault/',
    links: [
      { to: '/volet-roulant-bloque-herault/', label: 'Volet bloqué' },
      { to: '/reparation-moteur-volet-roulant-herault/', label: 'Moteur volet' },
      { to: '/changer-sangle-volet-roulant-herault/', label: 'Sangle' },
      { to: '/motorisation-volet-roulant-herault/', label: 'Motorisation' },
      { to: '/volet-roulant-electrique-herault/', label: 'Volet électrique' },
    ],
  },
  {
    title: 'Vitrage',
    to: '/vitrier-herault/',
    links: [
      { to: '/remplacement-vitre-cassee-herault/', label: 'Vitre cassée' },
      { to: '/remplacement-double-vitrage-herault/', label: 'Double vitrage' },
      { to: '/double-vitrage-embue-herault/', label: 'Vitrage embué' },
      { to: '/vitrier-urgence-herault/', label: 'Urgence vitrier' },
    ],
  },
  {
    title: 'Store & BSO',
    to: '/reparation-store-herault/',
    links: [
      { to: '/reparation-store-banne-herault/', label: 'Store banne' },
      { to: '/store-banne-bloque-herault/', label: 'Store bloqué' },
      { to: '/reparation-bso-herault/', label: 'BSO' },
      { to: '/motorisation-store-herault/', label: 'Motorisation' },
    ],
  },
  {
    title: 'Fenêtre',
    to: '/reparation-fenetre-herault/',
    links: [
      { to: '/fenetre-bloquee-herault/', label: 'Fenêtre bloquée' },
      { to: '/changer-cremone-fenetre-herault/', label: 'Crémone' },
      { to: '/reglage-oscillo-battant-herault/', label: 'Oscillo-battant' },
      { to: '/reparation-fenetre-pvc-alu-bois-herault/', label: 'PVC, alu, bois' },
    ],
  },
];

const villeColumns = [
  [
    { to: '/depannage-menuiserie-montpellier/', label: 'Montpellier' },
    { to: '/depannage-menuiserie-beziers/', label: 'Béziers' },
    { to: '/depannage-menuiserie-sete/', label: 'Sète' },
    { to: '/depannage-menuiserie-agde/', label: 'Agde' },
    { to: '/depannage-menuiserie-frontignan/', label: 'Frontignan' },
    { to: '/depannage-menuiserie-lattes/', label: 'Lattes' },
    { to: '/depannage-menuiserie-la-grande-motte/', label: 'La Grande-Motte' },
    { to: '/depannage-menuiserie-castelnau-le-lez/', label: 'Castelnau-le-Lez' },
  ],
  [
    { to: '/depannage-menuiserie-mauguio/', label: 'Mauguio' },
    { to: '/depannage-menuiserie-lunel/', label: 'Lunel' },
    { to: '/depannage-menuiserie-pezenas/', label: 'Pézenas' },
    { to: '/depannage-menuiserie-meze/', label: 'Mèze' },
    { to: '/depannage-menuiserie-juvignac/', label: 'Juvignac' },
    { to: '/depannage-menuiserie-clermont-l-herault/', label: 'Clermont-l\'Hérault' },
    { to: '/depannage-menuiserie-saint-jean-de-vedas/', label: 'Saint-Jean-de-Védas' },
  ],
  [
    { to: '/depannage-menuiserie-villeneuve-les-maguelone/', label: 'Villeneuve-lès-Maguelone' },
    { to: '/depannage-menuiserie-saint-gely-du-fesc/', label: 'Saint-Gély-du-Fesc' },
    { to: '/depannage-menuiserie-le-cres/', label: 'Le Crès' },
    { to: '/depannage-menuiserie-perols/', label: 'Pérols' },
    { to: '/depannage-menuiserie-grabels/', label: 'Grabels' },
    { to: '/depannage-menuiserie-pignan/', label: 'Pignan' },
    { to: '/depannage-menuiserie-marseillan/', label: 'Marseillan' },
  ],
];

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-white">
      {/* Top decorative band */}
      <div className="h-1 bg-accent-500" />

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 md:pt-16 pb-8">
        {/* Top row: Brand + Services */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Brand column - spans 3 */}
          <div className="lg:col-span-3">
            <Link to="/" className="inline-block" aria-label="DFPRO Hérault — Accueil">
              <LogoFooter />
            </Link>
            <p className="mt-4 text-white/65 font-body text-sm leading-relaxed max-w-xs">
              Spécialiste de la réparation de menuiseries aluminium et PVC. Baies coulissantes, volets roulants, vitrages, stores et fenêtres dans tout l'Hérault.
            </p>
            <div className="mt-5 space-y-3">
              <a
                href="tel:+33980802242"
                className="btn-call inline-flex text-sm px-5 py-2.5"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </span>
                09 80 80 22 42
              </a>
              <div>
                <a
                  href="mailto:herault@dfpro.fr"
                  className="inline-flex items-center gap-2 text-white/65 hover:text-accent-500 text-sm font-body transition-colors duration-200"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-sm"></i>
                  </span>
                  herault@dfpro.fr
                </a>
              </div>
            </div>
          </div>

          {/* Services columns - spans 6 */}
          <div className="lg:col-span-6">
            <h4 className="font-heading font-semibold text-xs uppercase tracking-widest text-white/40 mb-5">
              Nos services de réparation
            </h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-5">
              {serviceColumns.map((col) => (
                <div key={col.to}>
                  <Link
                    to={col.to}
                    className="font-heading font-semibold text-sm text-white hover:text-accent-500 transition-colors duration-200"
                  >
                    {col.title}
                  </Link>
                  <ul className="mt-2 space-y-1.5">
                    {col.links.map((link) => (
                      <li key={link.to}>
                        <Link
                          to={link.to}
                          className="text-white/55 hover:text-accent-500 text-xs font-body transition-colors duration-200"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Villes + liens column - spans 3 */}
          <div className="lg:col-span-3">
            <h4 className="font-heading font-semibold text-xs uppercase tracking-widest text-white/40 mb-5">
              Villes desservies
            </h4>
            <div className="grid grid-cols-3 gap-x-3 gap-y-1.5">
              {villeColumns.map((col, colIdx) => (
                <ul key={colIdx} className="space-y-1.5">
                  {col.map((ville) => (
                    <li key={ville.to}>
                      <Link
                        to={ville.to}
                        className="text-white/55 hover:text-accent-500 text-xs font-body transition-colors duration-200"
                      >
                        {ville.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              ))}
            </div>

            <div className="mt-6 pt-5 border-t border-white/10">
              <ul className="space-y-2">
                <li>
                  <Link to="/blog/" className="text-white/55 hover:text-accent-500 text-xs font-body transition-colors duration-200">
                    Blog &amp; Conseils
                  </Link>
                </li>
                <li>
                  <Link to="/contact/" className="text-white/55 hover:text-accent-500 text-xs font-body transition-colors duration-200">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/mentions-legales/" className="text-white/55 hover:text-accent-500 text-xs font-body transition-colors duration-200">
                    Mentions légales
                  </Link>
                </li>
                <li>
                  <Link to="/politique-de-confidentialite/" className="text-white/55 hover:text-accent-500 text-xs font-body transition-colors duration-200">
                    Politique de confidentialité
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs font-body text-center sm:text-left">
            &copy; {new Date().getFullYear()} DFPRO Hérault &mdash; Réparateur indépendant de menuiseries dans l'Hérault.
          </p>
          <p className="text-white/25 text-xs font-body text-center sm:text-right leading-relaxed max-w-lg">
            Technal, Sepalumic, Somfy, Bubendorff, Schüco sont des marques déposées par leurs propriétaires. DFPRO Hérault n'est affiliée à aucune de ces marques.
          </p>
        </div>
      </div>
    </footer>
  );
}